import { AbilityBuilder } from '@casl/ability'
import {TECHNICAL_ADMINISTRATOR, PROJECT_MANAGER, CCE, USER} from '@/lib/enums/user/role'

export default function defineAbilitiesFor (role) {
  return AbilityBuilder.define(
    (can, cannot) => {
      switch (role) {
        case TECHNICAL_ADMINISTRATOR:
          can(['create', 'update', 'delete', 'lock', 'export'], 'User')
          can(['export'], 'Site')
          can(['delete', 'create'], 'Site')
          can(['export'], 'Message')
          can(['export', 'create', 'delete'], 'Notification')
          can(['sync'], 'Ampere')
          can(['create', 'update'], 'Video')
          can(['create', 'delete'], 'Link')
          break
        case USER:
          break
        // case FUNCTIONAL_ADMINISTRATOR:
          // can(['create', 'update', 'delete'], 'User')
          // cannot(['update', 'delete'], 'User', {role: {code: 'TECHNICAL_ADMINISTRATOR'}})
          // break
        case PROJECT_MANAGER:
          // can('read', 'Post')
          break
        case CCE:
          // can('read', 'Post')
          break
      }
    })
}



// WEBPACK FOOTER //
// ./src/resources/ability.js